import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getCodeOverviewApi, getGraphApi, repoCloneApi } from "../../end-points/codeOverview.js";
import { toast } from "react-toastify";

const initialState = {
  repoPath: "",
  language: "",
  htmlFileURL: "",
  overview: "",
  repoLink: "",
  cloneSuccess: false,
  loading: false,
  showOverview: false
}

export const repoClone = createAsyncThunk(
  "codeOverview/repoClone", repoCloneApi
)

export const getGraph = createAsyncThunk(
  "codeOverview/getGraph", getGraphApi
)

export const getCodeOverview = createAsyncThunk(
  "codeOverview/getCodeOverview", getCodeOverviewApi
)


export const codeOverviewSlice = createSlice({
  name: "codeOverview",
  initialState,
  reducers: {
    updateOverview: (state, action) => {
      state.showOverview = action.payload;
    },
    updateClone: (state) => {
      state.cloneSuccess = false;
    },
    resetOverview: (state) => {
      state.overview = ""
    },
    resetCodeOverview: (state) => {
      state.overview = ""
      state.showOverview = false
    }
  },
  extraReducers: (builder) => {
    builder.addCase(repoClone.pending, (state) => {
      console.log("Loading...", state);
      state.loading = true;
    })
    builder.addCase(repoClone.fulfilled, (state, action) => {
      state.repoPath = action.payload.data.repo_path;
      state.language = action.payload.data.language;
      state.repoLink = action.payload.data.repoLink;
      state.cloneSuccess = true;
      toast.success("Cloned Successfully");
      state.loading = false;
    })
    builder.addCase(repoClone.rejected, (state, action) => {
      console.log("Error", state, action);
      toast.error(action.error.message)
      state.loading = false;
    })
    builder.addCase(getGraph.pending, (state) => {
      console.log("Loading...", state);
      state.loading = true;
    })
    builder.addCase(getGraph.fulfilled, (state, action) => {
      console.log("Success: ", state, action);
      state.loading = false;
      state.htmlFileUrl = action.payload;
    })
    builder.addCase(getGraph.rejected, (state, action) => {
      console.log("Error", state, action);
      toast.error(action.error.message)
      state.loading = false;
    })
    builder.addCase(getCodeOverview.pending, (state) => {
      console.log("Loading...", state);
      state.loading = true;
    })
    builder.addCase(getCodeOverview.fulfilled, (state, action) => {
      console.log("Success...", state, action);
      state.overview = action.payload.overview;
      state.showOverview = true;
      state.loading = false;
      const sessionValue = JSON.parse(sessionStorage.getItem("code-conversion-response"))
      sessionStorage.setItem(
        "code-conversion-response",
        JSON.stringify({
          ...sessionValue,
          overview: action.payload.overview
        })
      );
    })
    builder.addCase(getCodeOverview.rejected, (state, action) => {
      console.log("Error", state, action);
      toast.error(action.error.message)
      state.loading = false;
    })
  }
})

// Action creators are generated for each case reducer function
export const { updateOverview, updateClone, resetOverview, resetCodeOverview } = codeOverviewSlice.actions

export default codeOverviewSlice.reducer